import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import type { TableSortRule } from '@swf/poker';
import { SortFilterContainer as SortFilterContainerBase } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../../model';
import { ModalRoutes } from '../../../types';
import { hasAnyActiveUiFilters } from '../../../utils/filters';

const SortFilterContainer: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetId, widgetSelect, widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const activeUiFilters = useSelector(widgetSelect.getActiveUiFilters);
  const [sortByOpened, setSortByOpened] = useState(false);
  const hasActiveUiFilters = hasAnyActiveUiFilters(activeUiFilters);

  const handleFiltersClick = () =>
    modal.enqueue({
      path: ModalRoutes.MobileFiltersScreen,
      locationState: { widgetId }
    });

  const handleSortByClick = () => setSortByOpened((prev) => !prev);
  const sortRule = useSelector(widgetSelect.getTableSortRule);

  const handleOptionSelect = (payload: TableSortRule) => {
    widgetDispatch.setTableSortRule(payload);
    setSortByOpened(false);
  };

  const handleCloseSortBy = () => setSortByOpened(false);

  return (
    <SortFilterContainerBase
      hasFilters={hasActiveUiFilters}
      isSortByOpened={sortByOpened}
      onCloseSortBy={handleCloseSortBy}
      onFiltersClick={handleFiltersClick}
      onOptionSelect={handleOptionSelect}
      onSortByClick={handleSortByClick}
      sortRule={sortRule}
    />
  );
};

export default SortFilterContainer;
